import { useContext, useState } from 'react';
import { TtsTutorialContainer } from './styles';
import ReactJoyride, {
  ACTIONS,
  CallBackProps,
  EVENTS,
  STATUS,
} from 'react-joyride';
import { TutorialsContext } from '../../../contexts/TutorialsContext';

export const TtsTutorial = () => {
  const { running, setRunning, steps, setStatus } =
    useContext(TutorialsContext);

  const [stepIndex, setStepIndex] = useState(0);

  function handleCallback(data: CallBackProps) {
    const { action, index, status, type } = data;
    setStatus(status);

    if (
      [STATUS.FINISHED as string, STATUS.SKIPPED as string].includes(status)
    ) {
      setRunning(false);
      setStepIndex(0);
    } else if (
      [EVENTS.STEP_AFTER as string, EVENTS.TARGET_NOT_FOUND as string].includes(
        type
      )
    ) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setStepIndex(stepIndex);
    }
  }

  return (
    <TtsTutorialContainer>
      <ReactJoyride
        continuous
        callback={handleCallback}
        debug
        stepIndex={stepIndex}
        steps={steps}
        run={running}
        styles={{ options: { zIndex: 9999 } }}
      />
    </TtsTutorialContainer>
  );
};
